import React from 'react';
import { Icon } from 'react-fa';

import styles from './FormError.css';

export default function FormError(props) {
  return (
    <div className={styles.formError}>
      <Icon
        className={styles.formErrorIcon}
        name="exclamation-circle"
      />
      {props.children}
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./client/form/FormError.js
 **/